import type { EditorState } from '@/stateManagement';

const getLastKeyboardContext = (state: EditorState) =>
  state.mobile.mobileKeyboard.lastKeyboardContext;

const getIsCollapsingMenuFromKeyboard = (state: EditorState) =>
  state.mobile.mobileKeyboard.isCollapsingMenuFromKeyboard;

export { getLastKeyboardContext, getIsCollapsingMenuFromKeyboard };
